<template functional>
  <span :class="{'text-danger': props.stock <= 0, 'text-warning': props.stock < 5 && props.stock > 0}">
    {{ props.stock }}
  </span>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class ColoredStockNumber extends Vue {
  @Prop({required: true, type: Number})
  public readonly stock!: number;
}
</script>
